module.exports = __webpack_public_path__ + "media/images/sort_down-95bee6c18bd7c5be6496b060e6a90734.png";